import { Flex, FormInput } from '@sparrowengg/twigs-react';
import { WebhookStateValues } from 'features/apps/add-apps/types';
import { UseFormRegister } from 'react-hook-form';

const BasicAuthentication = ({
  register,
  errors
}: {
  register: UseFormRegister<WebhookStateValues>;
  errors: any;
}) => {
  return (
    <Flex flexDirection="column" gap="$8">
      <FormInput
        label="Username"
        requiredIndicator
        {...register('properties.headers.username', {
          required: 'Username is required'
        })}
        size="lg"
        placeholder='Ex: appnest'
        error={errors?.properties?.headers?.username?.message}
        errorBorder={errors?.properties?.headers?.username}
      />
      <FormInput
        label="Password"
        requiredIndicator
        {...register('properties.headers.password', {
          required: 'Password is required'
        })}
        size="lg"
        placeholder='Ex: sgh5dsgasf24'
        error={errors?.properties?.headers?.password?.message}
        errorBorder={errors?.properties?.headers?.password}
      />
    </Flex>
  );
};

export default BasicAuthentication;
